import { ReactNode, useState } from 'react'
import { ModalContext } from './ModalContext';

type TModalProvider = {
  children: ReactNode;
}

export const ModalProvider: React.FC<TModalProvider> = ({ children }) => {
  const initialState = {
    open: false,
    title: '',
    message: '',
    primaryAction: undefined,
    primaryActionLabel: '',
    isPrimaryDestructive: false
  };

  const [modalState, setModalState] = useState(initialState);

  const dispatchModal = (
    open: boolean, {
    title = initialState.title,
    message = initialState.message,
    primaryAction = initialState.primaryAction,
    primaryActionLabel = initialState.primaryActionLabel,
    isPrimaryDestructive = initialState.isPrimaryDestructive,
  } = {}) => {
      // check if required params are not null | undefined | empty string, otherwise throw error.
      switch (true) {
        case (open && !title):
          throw new Error('modal title param [string] is required.');
        case (open && !message):
          throw new Error('modal message param [string] is required.');
        default:
          break;
      }
      if (open) {
        setModalState({
          ...modalState,
          open: false,
        });
      }

      const newModalState = {
        open: open,
        title: title,
        message: message,
        primaryAction: primaryAction,
        primaryActionLabel: primaryActionLabel,
        isPrimaryDestructive: isPrimaryDestructive
      };

      return setModalState(newModalState);
    };

  return (
    <ModalContext.Provider value={{
      modalState: modalState,
      setModalState: setModalState,
      dispatchModal: dispatchModal
    }}>
      {children}
    </ModalContext.Provider>
  );
}
